/* eslint-disable */
import {
	Button,
	ButtonGroup,
	FormControl,
	InputLabel,
	MenuItem,
	Select,
	SelectChangeEvent,
	TextField
} from "@mui/material";
import { useAppDispatch } from "hooks";
import { PopUpVariant, WebstoreDialogVariant, WsDialogs } from "interfaces";
import { useState } from "react";
import { onOpenPopUp } from "redux/slices";
import { useDialogModalRedux } from "redux/slices/dialog/hooks/useDialogModalRedux";

const POPUP_VARIANTS: PopUpVariant[] = [
	"cgg-club-hopper",
	"cgg-event-completed",
	"cgg-more-info",
	"cgg-not-enough-club-members",
	"grant-reward-collected",
	"loyalty-points-added",
	"daily-login-earned-reward",
	"daily-login-streak-loyalty-points",
	"endless-offer-reward-collected",
	"bouncy-chest-reward-collected",
	"drip-offer-reward",
	"drip-offer-missed-event",
	"drip-offer-end",
	"pb-pbftue-v2",
	"pb-reward-collected-v3",
	"tutorial",
	"tutorial-loyalty-shop",
	"loyalty-points-info",
	"sign-up-incentive-reward",
	"rewarding-deeplink-reward"
] as const;

const POPUP_VARIANTS_DYNAMIC: string[] = [
	"single-item-info",
	"cgg-purchase-success"
] as const;

const POPUP_VARIANTS_REQUIRED_DATA: string[] = [
	"bundle-up",
	"bundle-up-info",
	"cgg-earned-reward",
	"cgg-eligibility-tools",
	"cgg-new-tier",
	"cgg-not-yet-contributed",
	"drip-offer",
	"drip-offer-info",
	"rebate-main-popup",
	"rebate-info-popup"
] as const;

const DIALOGS: WebstoreDialogVariant[] = [
	WsDialogs.SHOP_PURCHASE_SUCCESS,
	WsDialogs.LOYALTY_PURCHASE_SUCCESS,
	WsDialogs.ACCOUNT_NOT_CONNECTED,
	WsDialogs.INSUFFICIENT_LOYALTY_POINT_BALANCE
];

const DIALOGS_DYNAMIC: string[] = [];

const DIALOGS_REQUIRED_DATA: WebstoreDialogVariant[] = [
	WsDialogs.LOYALTY_PURCHASE_CONFIRM
];

const PopupTools = () => {
	const dispatch = useAppDispatch();
	const [popup, setPopup] = useState<PopUpVariant | WebstoreDialogVariant | "">(
		""
	);
	const [dynamicId, setDynamicId] = useState<string>("0");
	const { openDialog } = useDialogModalRedux();

	const handlePopupSelect = (event: SelectChangeEvent) => {
		setPopup(event.target.value as PopUpVariant | WebstoreDialogVariant);
	};

	const handleTrigger = () => {
		if (!popup) return;

		let finalPopup = popup;

		if (
			DIALOGS.find((d) => d === finalPopup) ||
			DIALOGS_DYNAMIC.find((d) => d === finalPopup)
		) {
			openDialog(finalPopup as WebstoreDialogVariant);
		} else {
			// Si es una variante dinámica, agregar el ID
			if (POPUP_VARIANTS_DYNAMIC.some((prefix) => popup.startsWith(prefix))) {
				finalPopup = `${popup}-${dynamicId}` as PopUpVariant;
			}

			dispatch(onOpenPopUp(finalPopup as PopUpVariant));
		}
	};

	return (
		<>
			<div>
				<FormControl fullWidth>
					<InputLabel>Popup</InputLabel>
					<Select value={popup} label="Popup" onChange={handlePopupSelect}>
						{POPUP_VARIANTS.map((variant) => (
							<MenuItem key={variant} value={variant}>
								{variant}
							</MenuItem>
						))}
						{/* Dynamic variants */}
						<MenuItem value="single-item-info">
							single-item-info-[Offer-ID]
						</MenuItem>
						<MenuItem value="cgg-purchase-success">
							cgg-purchase-success-[TIER-INDEX]
						</MenuItem>
						{/* Required data variants */}
						{POPUP_VARIANTS_REQUIRED_DATA.map((v) => (
							<MenuItem disabled key={v} value={v}>
								{v}-[Requires-organic-trigger]
							</MenuItem>
						))}
						{/* Dialogs */}
						{DIALOGS.map((dialog) => (
							<MenuItem key={dialog} value={dialog}>
								{dialog}
							</MenuItem>
						))}
						{DIALOGS_REQUIRED_DATA.map((dialog) => (
							<MenuItem disabled key={dialog} value={dialog}>
								{dialog}-[Requires-organic-trigger]
							</MenuItem>
						))}
					</Select>
				</FormControl>
				{(DIALOGS_DYNAMIC.some((prefix) => popup?.startsWith(prefix)) ||
					POPUP_VARIANTS_DYNAMIC.some((prefix) =>
						popup?.startsWith(prefix)
					)) && (
					<TextField
						fullWidth
						label="[Dynamic ID]"
						value={dynamicId}
						onChange={(e) => setDynamicId(e.target.value)}
						margin="normal"
					/>
				)}
				<div>
					<ButtonGroup disabled={!popup}>
						<Button onClick={handleTrigger}>Trigger</Button>
					</ButtonGroup>
				</div>
			</div>
			<br />
		</>
	);
};

export default PopupTools;
